import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function LeadUpload({ slot, onDone }) {
  const ref = useRef(null);
  const [drag, setDrag] = useState(false);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post(`/projects/${slot}/leads/upload`, fd);
      const desc = `${data.duplicates} dubbletter hoppades över · ${data.invalid} ogiltiga rader`;
      if (data.duplicates > 0) toast.warning(`Importerade ${data.imported} leads — ${data.duplicates} dubbletter skapades inte`, { description: desc, duration: 8000 });
      else toast.success(`Imported ${data.imported} leads`, { description: desc });
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div data-testid="lead-file-dropzone" onClick={() => ref.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }} onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); upload(e.dataTransfer.files[0]); }}
      className={`cursor-pointer rounded-xl border border-dashed p-6 flex items-center gap-4 transition-colors ${drag ? "border-primary bg-primary/10" : "border-input bg-card hover:bg-secondary/50"}`}>
      <div className="h-11 w-11 rounded-lg bg-primary/15 grid place-items-center shrink-0"><UploadCloud className="h-5 w-5 text-primary" /></div>
      <div className="min-w-0">
        <p className="font-medium text-sm">{busy ? "Importing…" : "Drop a CSV or Excel file, or click to browse"}</p>
        <p className="text-xs text-muted-foreground mt-0.5">.csv · .xlsx · .xls — columns like Email, Name, Company, Title are detected automatically</p>
      </div>
      <input ref={ref} type="file" accept=".csv,.xlsx,.xls" className="hidden" data-testid="lead-file-input"
        onChange={(e) => upload(e.target.files[0])} />
    </div>
  );
}
